import React from "react"

const Plus = () => {
  return (
    <div>Plus</div>
  )
}

export default Plus